import { render, staticRenderFns } from "./discover.vue?vue&type=template&id=5dd6eb62&"
import script from "./discover.vue?vue&type=script&lang=js&"
export * from "./discover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports